const general_tests_pt = require('./general_tests.json')
export default general_tests_pt